// extracted by mini-css-extract-plugin
export default {"main":"SmallVideo_main__l-Hwb","video":"SmallVideo_video__bIr22","img":"SmallVideo_img__fRUyx"};